import * as React from "react";
import { Grid } from "../grid/grid/grid.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import { Icon } from "../icon/icon/icon.mjs";
const Title = (props) => {
  const { title, gutter = "default", iconSize = "sm" } = props;
  return /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"], gutter }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#compare", size: iconSize, align: "none" })), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, /* @__PURE__ */ React.createElement(Heading, { element: "h1", className: "h3" }, title)));
};
export {
  Title
};
